import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReplacedView from './View';
import { ALERT_TYPE } from '../../../../data/enums/AlertType';
import { ORDER_TABS } from '../config';
import withAlert from '../../../../utils/composition/withAlert';
import { EVENT_OPERATION } from '../../../../data/enums/EventOperation';
import { handleFormSubmit } from '../../../../utils/crudResponseProcessor';
import { crudRequestConfig } from './config';
import { clone, filterItems } from '../../../../utils/arrayProcessor';
import { LIMIT, PAGE } from '../../../../data/enums/GeneralConstants';

const propTypes = {
  data: PropTypes.shape({
    list: PropTypes.array,
    total: PropTypes.number,
  }),
  activeLine: PropTypes.shape({
    id: PropTypes.number,
    sellerId: PropTypes.number,
  }),
  serverResponseWaiting: PropTypes.bool,
  stateSetter: PropTypes.func.isRequired,
  displayAlert: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onCallRowClick: PropTypes.func.isRequired,
  dispatchReplacementOrder: PropTypes.func.isRequired,
  handlePassiveTabListChange: PropTypes.func.isRequired,
};

const defaultProps = {
  data: {
    list: [],
    total: 0,
    limit: LIMIT,
    page: PAGE,
  },
  activeLine: {
    id: '',
    sellerId: 0,
  },
  serverResponseWaiting: false,
};

class Replaced extends Component {
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = {
      activeCall: {
        index: -1,
        value: '',
        sellerId: '',
      },
    };
    const serverCall = {
      [EVENT_OPERATION.DISPATCHED]: props.dispatchReplacementOrder,
    };
    this.onFormSubmit = handleFormSubmit(
      this.onServerRequestSuccess,
      this.onAPIRequestFailure,
      crudRequestConfig,
      serverCall,
    );
  }

  componentDidMount() {
    this.resetActiveCall();
  }

  handleRowClick = (callId, sellerId) => {
    const { onCallRowClick, data } = this.props;
    const { activeCall } = this.state;
    if (callId !== activeCall.value) {
      const indexInDataList = data.list.findIndex(
        element => element.Distributor.id === sellerId && element.id === callId,
      );
      activeCall.value = callId;
      activeCall.index = indexInDataList;
      this.setState({ activeCall });

      onCallRowClick(callId, sellerId);
    }
  };

  onServerRequestSuccess = type => (response, payload) => {
    const { displayAlert, data, stateSetter, handlePassiveTabListChange } = this.props;
    const dataList = clone(data.list);
    displayAlert(ALERT_TYPE.SUCCESS, crudRequestConfig[type].message);
    const selectedCall = filterItems(dataList, payload.replacementId)[0] || {};
    const selectedCallIndex = dataList.findIndex(call => call.id === selectedCall.id);
    dataList.splice(selectedCallIndex, 1);
    data.list = dataList;
    data.total -= 1;
    stateSetter(data, ORDER_TABS.REPLACED);
    handlePassiveTabListChange(payload.replacementId, ORDER_TABS[type], 1);
  };

  handlePageChange = pagination => {
    const { onPageChange } = this.props;
    onPageChange(ORDER_TABS.REPLACED, pagination);
  };

  onAPIRequestFailure = error => {
    const { displayAlert } = this.props;
    displayAlert(ALERT_TYPE.DANGER, error);
  };

  resetActiveCall = () => {
    const { activeCall } = this.state;
    activeCall.index = '';
    activeCall.value = '';
    activeCall.sellerId = '';
    this.setState({ activeCall });
  };

  render() {
    const { data, stateSetter, serverResponseWaiting } = this.props;

    const { activeCall } = this.state;

    return (
      <Fragment>
        <ReplacedView
          data={data}
          stateSetter={stateSetter}
          loading={serverResponseWaiting}
          onRowClick={this.handleRowClick}
          activeCallIndex={activeCall.index}
          onPageChange={this.handlePageChange}
          onOrderStatusChangeClick={this.onFormSubmit}
        />
      </Fragment>
    );
  }
}

Replaced.propTypes = propTypes;

Replaced.defaultProps = defaultProps;

export default withAlert()(Replaced);
